// Translation keys and text for the application
export type TranslationKey = 
  // Navigation
  | 'nav.home'
  | 'nav.search' 
  | 'nav.about'
  | 'nav.admin'
  
  // Home page
  | 'home.title'
  | 'home.subtitle'
  | 'home.browse_collection'
  | 'home.featured_resources'
  | 'home.view_all'
  | 'home.digital_knowledge_hub'
  
  // Feature cards
  | 'home.features.books_count'
  | 'home.features.books_desc' 
  | 'home.features.research_title'
  | 'home.features.research_desc'
  | 'home.features.access_title'
  | 'home.features.access_desc'
  
  // About page
  | 'about.badge'
  | 'about.mission_title'
  | 'about.mission_subtitle'
  | 'about.what_we_do_title'
  | 'about.what_we_do_desc'
  | 'about.free_access_title'
  | 'about.free_access_desc'
  | 'about.quality_curated_title'
  | 'about.quality_curated_desc'
  | 'about.commitment_title'
  | 'about.stats.resources'
  | 'about.stats.free_access'
  | 'about.stats.always_available'
  
  // Search page
  | 'search.title'
  | 'search.subtitle'
  | 'search.placeholder'
  | 'search.results_for'
  | 'search.found_results'
  | 'search.no_results'
  | 'search.no_results_desc'
  | 'search.start_search'
  | 'search.start_search_desc'
  | 'search.filter.all'
  | 'search.filter.books'
  | 'search.filter.papers'
  | 'search.filter.open_access'
  | 'search.filter.recent'
  
  
  // Item details
  | 'item.authors'
  | 'item.year'
  | 'item.type'
  | 'item.license'
  | 'item.description'
  | 'item.download'
  
  // Common
  | 'common.loading'
  | 'common.book'
  | 'common.paper'
  | 'common.close'
  | 'common.search'
  
  // Theme
  | 'theme.darkMode'
  | 'theme.lightMode'

export const translations = {
  en: {
    // Navigation
    'nav.home': 'Home',
    'nav.search': 'Search',
    'nav.about': 'About',
    'nav.admin': 'Admin',
    
    // Home page
    'home.title': 'Welcome to Sudan\'s Library',
    'home.subtitle': 'Discover knowledge through our collection of open access books, research papers, and educational materials.',
    'home.browse_collection': 'Browse Collection',
    'home.featured_resources': 'Featured Resources',
    'home.view_all': 'View All',
    'home.digital_knowledge_hub': 'Digital Knowledge Hub',
    
    // Home page features
    'home.features.books_count': 'Books',
    'home.features.books_desc': 'Comprehensive digital library',
    'home.features.research_title': 'Research Papers',
    'home.features.research_desc': 'Latest academic publications',
    'home.features.access_title': 'Fast Access',
    'home.features.access_desc': 'Search and download instantly',
    
    // About page
    'about.badge': 'About SudanLibrary',
    'about.mission_title': 'Our Mission',
    'about.mission_subtitle': 'Making knowledge accessible to everyone, everywhere',
    'about.what_we_do_title': 'What We Do',
    'about.what_we_do_desc': 'SudanLibrary is a digital platform dedicated to providing free access to knowledge. We share public-domain and open-access materials, and for other items, we provide direct links to their original sources.',
    'about.free_access_title': 'Free Access',
    'about.free_access_desc': 'All materials on our platform are freely accessible without registration or fees.',
    'about.quality_curated_title': 'Quality Curated',
    'about.quality_curated_desc': 'Our collection is carefully curated to ensure high-quality, reliable content.',
    'about.commitment_title': 'Our Commitment',
    'about.stats.resources': 'Resources Available',
    'about.stats.free_access': 'Free Access',
    'about.stats.always_available': 'Always Available',
    
    // Search page
    'search.title': 'Find Your Next Read',
    'search.subtitle': 'Search through our collection of books, papers, and research materials',
    'search.placeholder': 'Search by title, author, subject, or keywords...',
    'search.results_for': 'Search Results for',
    'search.found_results': 'Found',
    'search.no_results': 'No results found',
    'search.no_results_desc': 'Try searching with different keywords or check your spelling',
    'search.start_search': 'Start Your Search',
    'search.start_search_desc': 'Use the search bar above to find books, papers, and research materials',
    'search.filter.all': 'All',
    'search.filter.books': 'Books',
    'search.filter.papers': 'Papers',
    'search.filter.open_access': 'Open Access',
    'search.filter.recent': 'Recent',
    
    // Item details
    'item.authors': 'Authors',
    'item.year': 'Year',
    'item.type': 'Type',
    'item.license': 'License',
    'item.description': 'Description',
    'item.download': 'Request Download',
    
    // Common
    'common.loading': 'Loading...',
    'common.book': 'Book',
    'common.paper': 'Paper',
    'common.close': 'Close',
    'common.search': 'Search',
    
    // Theme
    'theme.darkMode': 'Dark Mode',
    'theme.lightMode': 'Light Mode'
  },
  
  ar: {
    // Navigation
    'nav.home': 'الرئيسية',
    'nav.search': 'البحث',
    'nav.about': 'من نحن؟',
    'nav.admin': 'المدير',
    
    // Home page
    'home.title': 'مرحباً بكم في مكتبة السودان المفتوحة',
    'home.subtitle': 'اكتشف المعرفة من خلال مجموعتنا من الكتب والأوراق البحثية والمواد التعليمية المفتوحة المصدر.',
    'home.browse_collection': 'تصفح المجموعة',
    'home.featured_resources': 'المصادر المميزة',
    'home.view_all': 'عرض الكل',
    'home.digital_knowledge_hub': 'عن مكتبة السودان المفتوحة',
    
    // Home page features
    'home.features.books_count': 'عدد ضخم من الكتب',
    'home.features.books_desc': 'مكتبة رقمية شاملة',
    'home.features.research_title': 'أوراق بحث علمي',
    'home.features.research_desc': 'أحدث المنشورات الأكاديمية',
    'home.features.access_title': 'بحث سريع',
    'home.features.access_desc': 'بحث وتحميل فوري',
    
    // About page
    'about.badge': 'عن مكتبة السودان المفتوحة',
    'about.mission_title': 'مهمتنا',
    'about.mission_subtitle': 'جعل المعرفة في متناول الجميع، في كل مكان',
    'about.what_we_do_title': 'ما نفعله',
    'about.what_we_do_desc': 'مكتبة السودان المفتوحة هي منصة رقمية مخصصة لتوفير وصول مجاني للمعرفة. نحن نشارك المواد ذات الملكية العامة ونوفر روابط مباشرة لمصادرها.',
    'about.free_access_title': 'وصول مجاني',
    'about.free_access_desc': 'جميع المواد على منصتنا متاحة بحرية دون تسجيل أو رسوم.',
    'about.quality_curated_title': 'منسقة بجودة عالية',
    'about.quality_curated_desc': 'مجموعتنا منسقة بعناية لضمان محتوى عالي الجودة وموثوق.',
    'about.commitment_title': 'التزامنا',
    'about.stats.resources': 'الموارد المتاحة',
    'about.stats.free_access': 'وصول مجاني',
    'about.stats.always_available': 'متاح دائماً',
    
    // Search page
    'search.title': 'ابحث عن قراءتك التالية',
    'search.subtitle': 'ابحث في مجموعتنا من الكتب والأوراق البحثية والمواد البحثية',
    'search.placeholder': 'البحث بالعنوان، المؤلف، الموضوع، أو الكلمات المفتاحية...',
    'search.results_for': 'نتائج البحث لـ',
    'search.found_results': 'تم العثور على',
    'search.no_results': 'لم يتم العثور على نتائج',
    'search.no_results_desc': 'جرب البحث بكلمات مفتاحية مختلفة أو تحقق من الإملاء',
    'search.start_search': 'ابدأ البحث',
    'search.start_search_desc': 'استخدم شريط البحث أعلاه للعثور على الكتب والأوراق البحثية والمواد البحثية',
    'search.filter.all': 'الكل',
    'search.filter.books': 'الكتب',
    'search.filter.papers': 'الأوراق البحثية',
    'search.filter.open_access': 'الوصول المفتوح',
    'search.filter.recent': 'الحديثة',
    
    // Item details
    'item.authors': 'المؤلفون',
    'item.year': 'السنة',
    'item.type': 'النوع',
    'item.license': 'الرخصة',
    'item.description': 'الوصف',
    'item.download': 'طلب التحميل',
    
    // Common
    'common.loading': 'جاري التحميل...',
    'common.book': 'كتاب',
    'common.paper': 'ورقة بحثية',
    'common.close': 'إغلاق',
    'common.search': 'بحث',
    
    // Theme
    'theme.darkMode': 'الوضع المظلم',
    'theme.lightMode': 'الوضع المضيء'
  }
} as const

// Hook for using translations
import { useLanguage } from '../contexts/LanguageContext'

export const useTranslation = () => {
  const { language } = useLanguage()
  
  const t = (key: TranslationKey): string => {
    return translations[language][key] || translations.en[key] || key
  }
  
  return { t, language }
}

export default useTranslation